import '../stylesheets/tailwind.css';

// stimulus and turbo stuff
import { Application } from '@hotwired/stimulus';

const application = Application.start();

import FieldErrorsController from '../controllers/field_errors_controller';
import ToastController from '../controllers/toast_controller';
import NavbarController from '../controllers/navbar_controller';
import MobileMenuController from '../controllers/mobile_menu_controller';
import DropdownController from '../controllers/dropdown_controller';
import ActionMenuController from '../controllers/action_menu_controller';
import SignupFormController from '../controllers/signup_form_controller';
import CityAutocompleteController from '../controllers/city_autocomplete_controller';
import SelectController from '../controllers/select_controller';
import ConditionalFieldController from '../controllers/conditional_field_controller';
import NestedFormController from '../controllers/nested_form_controller';
import CollapsibleController from '../controllers/collapsible_controller';
import AudioPreviewController from '../controllers/audio_preview_controller';
import AudioTrimmerController from '../controllers/audio_trimmer_controller';
import AudioRemoteController from '../controllers/audio_remote_controller';
import NowPlayingController from '../controllers/now_playing_controller';
import StatusPollController from '../controllers/status_poll_controller';
import ImagePreviewController from '../controllers/image_preview_controller';
import DialogController from '../controllers/dialog_controller';
import SortableController from '../controllers/sortable_controller';
import RowCardController from '../controllers/row_card_controller';
import RowHeadingController from '../controllers/row_heading_controller';
import DateRangeController from '../controllers/date_range_controller';
import FileFieldController from '../controllers/file_field_controller';
import ErrorFocusController from '../controllers/error_focus_controller';
import RequestSizeController from '../controllers/request_size_controller';
import ToastContainerController from '../controllers/toast_container_controller';
import InvitationTokenExchangeController from '../controllers/invitation_token_exchange_controller';
import LocalDatetimeController from '../controllers/local_datetime_controller';
import ClipboardController from '../controllers/clipboard_controller';
import BusyFrameController from '../controllers/busy_frame_controller';
import FormBusyController from '../controllers/form_busy_controller';
import ImageLightboxController from '../controllers/image_lightbox_controller';
import ProfileLayoutController from '../controllers/profile_layout_controller';
import CalendarLayersController from '../controllers/calendar_layers_controller';
import AnchorFocusController from '../controllers/anchor_focus_controller';
import LoadableController from '../controllers/loadable_controller';

application.register('field-errors', FieldErrorsController);
application.register('toast', ToastController);
application.register('navbar', NavbarController);
application.register('mobile-menu', MobileMenuController);
application.register('dropdown', DropdownController);
application.register('action-menu', ActionMenuController);
application.register('signup-form', SignupFormController);
application.register('city-autocomplete', CityAutocompleteController);
application.register('select', SelectController);
application.register('conditional-field', ConditionalFieldController);
application.register('nested-form', NestedFormController);
application.register('collapsible', CollapsibleController);
application.register('audio-preview', AudioPreviewController);
application.register('audio-trimmer', AudioTrimmerController);
application.register('audio-remote', AudioRemoteController);
application.register('now-playing', NowPlayingController);
application.register('status-poll', StatusPollController);
application.register('image-preview', ImagePreviewController);
application.register('dialog', DialogController);
application.register('sortable', SortableController);
application.register('row-card', RowCardController);
application.register('row-heading', RowHeadingController);
application.register('date-range', DateRangeController);
application.register('file-field', FileFieldController);
application.register('error-focus', ErrorFocusController);
application.register('request-size', RequestSizeController);
application.register('toast-container', ToastContainerController);
application.register('invitation-token-exchange', InvitationTokenExchangeController);
application.register('local-datetime', LocalDatetimeController);
application.register('clipboard', ClipboardController);
application.register('busy-frame', BusyFrameController);
application.register('form-busy', FormBusyController);
application.register('image-lightbox', ImageLightboxController);
application.register('profile-layout', ProfileLayoutController);
application.register('calendar-layers', CalendarLayersController);
application.register('anchor-focus', AnchorFocusController);
application.register('loadable', LoadableController);
